import { TAG_BLACKLIST } from '../shared/globals';

const MIN_TAG_LENGTH = 2;

/**
 * Verifica se a tag é válida para uso como palavra-chave de busca.
 * Bloqueia: vazias, só numéricas, muito curtas, termos banidos.
 */
export function isValidTag(tag: string): boolean {
  if (!tag || !tag.trim()) return false;
  const t = tag.trim();
  if (t.length < MIN_TAG_LENGTH) return false;
  if (/^_+$/.test(t) || /^\d+$/.test(t.replace(/\s/g, ''))) return false;
  const tNorm = t.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  if (TAG_BLACKLIST.includes(tNorm)) return false;
  return true;
}

/**
 * Normaliza a tag mantendo as palavras como digitadas.
 * Apenas trim, colapsa espaços múltiplos e remove HTML — sem remover acentos nem trocar por underscore.
 */
export function sanitizeTag(tag: string): string {
  return tag
    .replace(/<[^>]*>/g, '')
    .trim()
    .replace(/\s+/g, ' ');
}

/**
 * Retorna um novo array com a tag adicionada se for válida e não existir na lista.
 */
export function addTagUnique(tag: string, tags: string[]): string[] {
  if (!tag || tag === '_') return tags;
  if (!isValidTag(tag)) return tags;
  if (tags.includes(tag)) return tags;
  return [...tags, tag];
}
